import { useTheme } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import type { CustomSvgIconsProps, SvgPathProps } from './CustomSvgIcons.types';
import { viewBoxes } from './CustomSvgIcons.types';

const SvgPath = ({
  iconType,
  shapeId,
  solidColor,
}: SvgPathProps): React.ReactElement => {
  if (iconType === 'bold') {
    return (
      <path
        d="M 95.683594 186.921875 C 66.582031 186.921875 41.214844 166.3125 35.238281 137.921875 C 28.984375 120.261719 33.585938 88.917969 50.535156 70.082031 C 52.03125 68.429688 54.46875 67.996094 56.433594 69.097656 C 58.402344 70.199219 59.34375 72.480469 58.714844 74.644531 C 57.929688 77.355469 57.890625 81.289062 58.636719 85.8125 C 59.265625 89.546875 61.664062 93.558594 64.339844 96.824219 C 61.46875 72.480469 70.476562 61.902344 79.246094 51.636719 C 88.09375 41.253906 96.429688 31.460938 94.464844 5.664062 C 94.308594 3.582031 95.488281 1.652344 97.453125 0.867188 C 99.378906 0.0820312 101.621094 0.628906 102.957031 2.242188 C 126.4375 30.753906 121.441406 55.335938 118.140625 71.617188 C 115.859375 82.746094 115.386719 87.1875 119.160156 89.746094 C 120.929688 90.925781 121.953125 90.648438 122.976562 89.863281 C 126.710938 86.953125 129.738281 76.214844 125.492188 64.378906 C 124.785156 62.453125 125.375 60.328125 126.988281 59.03125 C 128.558594 57.734375 130.800781 57.613281 132.53125 58.636719 C 151.605469 70.316406 156.601562 101.1875 157.464844 125.019531 C 158.015625 140.910156 152.117188 156.089844 140.832031 167.808594 C 128.992188 179.960938 112.554688 186.921875 95.683594 186.921875 Z M 44.558594 135.71875 C 49.515625 159.824219 70.984375 177.324219 95.644531 177.324219 C 109.957031 177.324219 123.878906 171.425781 133.789062 161.121094 C 143.269531 151.332031 148.222656 138.628906 147.75 125.335938 C 147.003906 104.179688 143.269531 87.660156 137.015625 77.121094 C 136.78125 85.734375 133.910156 93.402344 128.796875 97.375 C 124.3125 100.875 118.6875 100.953125 113.734375 97.648438 C 104.257812 91.238281 106.417969 80.777344 108.660156 69.648438 C 111.414062 56.199219 114.71875 39.996094 103.941406 20.570312 C 102.171875 39.40625 93.953125 49.082031 86.519531 57.8125 C 77.121094 68.824219 69.019531 78.378906 75.980469 107.246094 C 76.375 108.820312 75.941406 110.46875 74.839844 111.648438 C 73.738281 112.828125 72.125 113.378906 70.554688 113.105469 C 63.632812 111.964844 52.070312 99.496094 49.472656 88.722656 C 41.765625 104.296875 40.191406 123.488281 44.363281 134.890625 C 44.441406 135.167969 44.519531 135.441406 44.558594 135.71875 Z M 44.558594 135.71875 "
        id={shapeId}
        fill={solidColor ? 'currentColor' : 'white'}
        fillRule="nonzero"
        fillOpacity="1"
        strokeOpacity={1}
        stroke={solidColor ? 'currentColor' : ''}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  } else if (iconType === 'normal') {
    return (
      <path
        d="M 95.683594 186.921875 C 66.582031 186.921875 41.214844 166.3125 35.238281 137.921875 C 28.984375 120.261719 33.585938 88.917969 50.535156 70.082031 C 52.03125 68.429688 54.46875 67.996094 56.433594 69.097656 C 58.402344 70.199219 59.34375 72.480469 58.714844 74.644531 C 57.929688 77.355469 57.890625 81.289062 58.636719 85.8125 C 59.265625 89.546875 61.664062 93.558594 64.339844 96.824219 C 61.46875 72.480469 70.476562 61.902344 79.246094 51.636719 C 88.09375 41.253906 96.429688 31.460938 94.464844 5.664062 C 94.308594 3.582031 95.488281 1.652344 97.453125 0.867188 C 99.378906 0.0820312 101.621094 0.628906 102.957031 2.242188 C 126.4375 30.753906 121.441406 55.335938 118.140625 71.617188 C 115.859375 82.746094 115.386719 87.1875 119.160156 89.746094 C 120.929688 90.925781 121.953125 90.648438 122.976562 89.863281 C 126.710938 86.953125 129.738281 76.214844 125.492188 64.378906 C 124.785156 62.453125 125.375 60.328125 126.988281 59.03125 C 128.558594 57.734375 130.800781 57.613281 132.53125 58.636719 C 151.605469 70.316406 156.601562 101.1875 157.464844 125.019531 C 158.015625 140.910156 152.117188 156.089844 140.832031 167.808594 C 128.992188 179.960938 112.554688 186.921875 95.683594 186.921875 Z M 44.558594 135.71875 C 49.515625 159.824219 70.984375 177.324219 95.644531 177.324219 C 109.957031 177.324219 123.878906 171.425781 133.789062 161.121094 C 143.269531 151.332031 148.222656 138.628906 147.75 125.335938 C 147.003906 104.179688 143.269531 87.660156 137.015625 77.121094 C 136.78125 85.734375 133.910156 93.402344 128.796875 97.375 C 124.3125 100.875 118.6875 100.953125 113.734375 97.648438 C 104.257812 91.238281 106.417969 80.777344 108.660156 69.648438 C 111.414062 56.199219 114.71875 39.996094 103.941406 20.570312 C 102.171875 39.40625 93.953125 49.082031 86.519531 57.8125 C 77.121094 68.824219 69.019531 78.378906 75.980469 107.246094 C 76.375 108.820312 75.941406 110.46875 74.839844 111.648438 C 73.738281 112.828125 72.125 113.378906 70.554688 113.105469 C 63.632812 111.964844 52.070312 99.496094 49.472656 88.722656 C 41.765625 104.296875 40.191406 123.488281 44.363281 134.890625 C 44.441406 135.167969 44.519531 135.441406 44.558594 135.71875 Z M 44.558594 135.71875 "
        id={shapeId}
        fill={solidColor ? 'currentColor' : 'white'}
        fillRule="nonzero"
        fillOpacity="1"
        strokeOpacity={1}
        strokeWidth="1.1"
        stroke={solidColor ? 'currentColor' : ''}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  } else {
    return (
      <path
        d="M 95.683594 186.921875 C 66.582031 186.921875 41.214844 166.3125 35.238281 137.921875 C 28.984375 120.261719 33.585938 88.917969 50.535156 70.082031 C 52.03125 68.429688 54.46875 67.996094 56.433594 69.097656 C 58.402344 70.199219 59.34375 72.480469 58.714844 74.644531 C 57.929688 77.355469 57.890625 81.289062 58.636719 85.8125 C 59.265625 89.546875 61.664062 93.558594 64.339844 96.824219 C 61.46875 72.480469 70.476562 61.902344 79.246094 51.636719 C 88.09375 41.253906 96.429688 31.460938 94.464844 5.664062 C 94.308594 3.582031 95.488281 1.652344 97.453125 0.867188 C 99.378906 0.0820312 101.621094 0.628906 102.957031 2.242188 C 126.4375 30.753906 121.441406 55.335938 118.140625 71.617188 C 115.859375 82.746094 115.386719 87.1875 119.160156 89.746094 C 120.929688 90.925781 121.953125 90.648438 122.976562 89.863281 C 126.710938 86.953125 129.738281 76.214844 125.492188 64.378906 C 124.785156 62.453125 125.375 60.328125 126.988281 59.03125 C 128.558594 57.734375 130.800781 57.613281 132.53125 58.636719 C 151.605469 70.316406 156.601562 101.1875 157.464844 125.019531 C 158.015625 140.910156 152.117188 156.089844 140.832031 167.808594 C 128.992188 179.960938 112.554688 186.921875 95.683594 186.921875 Z M 44.558594 135.71875 C 49.515625 159.824219 70.984375 177.324219 95.644531 177.324219 C 109.957031 177.324219 123.878906 171.425781 133.789062 161.121094 C 143.269531 151.332031 148.222656 138.628906 147.75 125.335938 C 147.003906 104.179688 143.269531 87.660156 137.015625 77.121094 C 136.78125 85.734375 133.910156 93.402344 128.796875 97.375 C 124.3125 100.875 118.6875 100.953125 113.734375 97.648438 C 104.257812 91.238281 106.417969 80.777344 108.660156 69.648438 C 111.414062 56.199219 114.71875 39.996094 103.941406 20.570312 C 102.171875 39.40625 93.953125 49.082031 86.519531 57.8125 C 77.121094 68.824219 69.019531 78.378906 75.980469 107.246094 C 76.375 108.820312 75.941406 110.46875 74.839844 111.648438 C 73.738281 112.828125 72.125 113.378906 70.554688 113.105469 C 63.632812 111.964844 52.070312 99.496094 49.472656 88.722656 C 41.765625 104.296875 40.191406 123.488281 44.363281 134.890625 C 44.441406 135.167969 44.519531 135.441406 44.558594 135.71875 Z M 44.558594 135.71875 "
        id={shapeId}
        fill={solidColor ? 'currentColor' : 'white'}
        fillRule="nonzero"
        fillOpacity="1"
        strokeOpacity={1}
        strokeWidth="1.4"
        stroke={solidColor ? 'currentColor' : ''}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  }
};

export const LevelingUpIcon = ({
  shouldbegradient,
  transitionduration = 0.4,
  prefix,
  solidColor,
  iconType = 'normal',
  gradientColor,
  ...props
}: CustomSvgIconsProps): React.ReactElement => {
  const currColorId = `${prefix}_levelingUpCurrentColorGradient`;
  const newColorId = `${prefix}_levelingUpNewColorGradient`;
  const shapeId = `${prefix}_levelingUpShape`;
  const theme = useTheme();
  const isLight = theme.palette.type === 'light';
  const colorsDark = {
    base: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.tealColors?.PLUS_2,
    },
  };
  const colorsLight = {
    base: {
      start: theme.palette?.greyColors?.PLUS_4,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.tealColors?.PLUS_3,
      stop: theme.palette.tealColors?.PLUS_2,
    },
  };
  const svgColors = isLight ? colorsLight : colorsDark;
  return (
    <SvgIcon {...props} viewBox={'-15 -15 220 220'}>
      {solidColor ? (
        <SvgPath
          shapeId={shapeId}
          iconType={iconType}
          solidColor={solidColor}
        />
      ) : (
        <>
          <defs>
            <linearGradient
              style={{
                transition: `${transitionduration}s`,
              }}
              id={currColorId}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%">
              <stop offset="0" stopColor={svgColors.base.start} />
              <stop offset="1" stopColor={svgColors.base.stop} />
            </linearGradient>
            <linearGradient id={newColorId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0" stopColor={svgColors.hover.start} />
              <stop offset="1" stopColor={svgColors.hover.stop} />
            </linearGradient>
          </defs>

          <g
            style={{
              stroke: `url("#${currColorId}")`,
            }}>
            <SvgPath
              shapeId={shapeId}
              iconType={iconType}
              solidColor={solidColor}
            />
          </g>
          <use
            xlinkHref={`#${shapeId}`}
            style={{
              stroke: `url("#${newColorId}")`,
              transition: `${transitionduration}s`,
              opacity: shouldbegradient ? 1 : 0,
            }}
          />
        </>
      )}
    </SvgIcon>
  );
};
